module.exports = __webpack_public_path__ + "static/ziggy_after-50192cf47153601227f2e934fd46704c.png";